import {styled} from "@mui/material/styles";
import {AlertGeneric} from "../CustomAlert.styles";

export const AlertDangerStyle = styled(AlertGeneric)(({theme}) => ({
    backgroundColor: theme.palette.error.light,
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
}));